<mat-dialog-content>
  <p *ngIf="type === 'warning'">
    <i class="fas fa-exclamation-triangle fa-2x" style="color: red;"></i>
  </p>
  <p *ngIf="type === 'continue'">
    <i class="fas fa-cloud-upload-alt fa-2x" style="color:dodgerblue;"></i>
  </p>
	<p>
	  {{message}}
	</p>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-raised-button color="primary" (click)="confirm()" tabindex="1">{{confirmButtonText}}</button>
	<button mat-raised-button color="warn" mat-dialog-close (click)="cancel()" tabindex="-1">{{cancelButtonText}}</button>
</mat-dialog-actions>

